export const formatNumberToLocaleString = (value: number | string) =>
  typeof value === "number" ? value.toLocaleString() : value;

export const mean = (values: number[]): number | null =>
  values.length === 0
    ? null
    : values.reduce((acc, v) => acc + v, 0) / values.length;
